import request from './request';
import "custom-event-polyfill";

import { setCustomerConfig, setSystemSettings, setUserSettings, getUserSettings } from './SettingsRetriever';

import EnvConfig from '../settings/current.json';

export default (netonline) => new Promise((resolve, reject) => {
    let ipRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
    let url = window.location.hostname;
    if (ipRegex.test(window.location.hostname)){
        // this is an ip address! 
        url = 'steamboat.spotliobooking.xyz';
    }
    const path = window.location.pathname.split('/').length > 1 ? '/' + window.location.pathname.split('/')[1] : '';
    const customers = EnvConfig.customers;
    let customerExists = false;

    if(customers.length < 1){
        reject('no destination found (0)');
    } else {
        const finishLoad = (customerConfig, result, customer, url, needsResolution = true) => {
            let urlAux = url.split('/');
            if(urlAux.length > 1) {
                urlAux = urlAux[0];
            } else {
                urlAux = url;
            }
            let ret = { customer: customer, config: customerConfig };
            let _path = url.match(urlAux + path) ? path : '';
            const settings = {...result, urlPrefix: _path};
            setCustomerConfig(ret);
            setSystemSettings(settings);
            window.dispatchEvent(new CustomEvent("updatedSystemSettings", {detail: settings}))
            if (!getUserSettings()) {
                let selected = settings.app.currency.default;
                if (settings.app.currency.defaultSecondary){
                    if (settings.app.currency.list.find(curr => curr.base === settings.app.currency.defaultSecondary)){
                        selected = settings.app.currency.list.indexOf(settings.app.currency.list.find(curr => curr.base === settings.app.currency.defaultSecondary))
                    }
                }
                setUserSettings({
                    currencies: {
                        selected
                    }
                });
            }
            if (needsResolution) {
                resolve([ret, settings]);
            }
        }
    
        const queryFromRemote = (customerFileName, customerSettingsFileName, customer, url, needsResolution) => {
            Promise.all([
                request({
                    url: 'https://s3.amazonaws.com/spotlio-react-booking-configurations/customers/' + customerFileName,
                    method: 'GET'
                }),
                request({
                    url: EnvConfig.endpoint + '/react-booking-settings/' + customerSettingsFileName,
                    method: 'GET'
                })
            ]).then((resArr) => {
                const customerConfig = resArr[0].data;
                const result = resArr[1].data;
                finishLoad(customerConfig, result, customer, url, needsResolution);
            }).catch(() => reject('no destination found (1)'));
        }
    
        customers.forEach((customer, idx) => {
            customer.urls.forEach((_url, jdx) => {
                if (_url === url + path || _url === url) {
                    customerExists = true;
                    const customerSettingsFileName = customer.name + '.json';
                    const customerFileName = customer.name + '/' + customer.stage + '.json';
    
                    Promise.all([
                        import('../settings/local/react-booking-settings/' + customerSettingsFileName),
                        import('../settings/local/customers/' + customerFileName)
                    ]).then((resArr) => {
                        const customerSettings = resArr[0].default;
                        const customerConf = resArr[1].default;
        
                        if (customerConf && customerSettings) {
                            if (netonline === true) {
                                queryFromRemote(customerFileName, customerSettingsFileName, customer, _url, true);
                            } else {
                                finishLoad(customerConf, customerSettings, customer, _url, true);
                            }
                        } else {
                            queryFromRemote(customerFileName, customerSettingsFileName, customer, _url, true);
                        }
                    }).catch(() => {
                        queryFromRemote(customerFileName, customerSettingsFileName, customer, _url, true);
                    });
    
                }
                if ((idx + 1) === customers.length && (jdx + 1) === customer.urls.length && !customerExists) {
                    reject('no destination found (2)');
                }
            })
        })
    }

});
